<template>
  <div class="container container-flexcenter">
    <TenderPlug
      :title="$t('Create your first project')"
      :description="
        $t('You can import the estimate in Excel format or create a project from a blank sheet')
      "
      :action-text="$t('Create new project')"
      @action="$emit('new')"
    >
      <template #icon><BurgerDots :style="{ height: '50px' }" /></template>
    </TenderPlug>
  </div>
</template>

<script>
  import TenderPlug from '@/components/tender/TenderPlug';
  import BurgerDots from '@/assets/icons/burger-dots.svg';

  export default {
    name: 'ProjectsEmpty',
    components: { TenderPlug, BurgerDots },
  };
</script>
